import styles from "./horizontalTextDivider.module.scss";

export interface HorizontalTextDividerProps {
  text: string;
}

function HorizontalTextDivider(props: HorizontalTextDividerProps) {
  const { text } = props;

  return <div className={styles.textDivider}>{text}</div>;
}

export default HorizontalTextDivider;
